export const INVALID_ISSUE_KEY_MESSAGE = 'Must be a valid issue key.';
/*
 The issue key regex is taken from AMKT:
 https://bitbucket.org/atlassian-marketplace/amkt/src/67f0e1f855ddb2905a8bbc7e79b60da6e162c583/webapp/src/main/scala/com/atlassian/marketplace/http/FieldValidation.scala#lines-115
*/

export const validateIssueKey = value => value && value.match('^[A-Za-z]{1,10}-?[A-Za-z]+-\\d+$') != null ? undefined : INVALID_ISSUE_KEY_MESSAGE;